/* Featured-products chips: switch the visible category panel. Server-rendered
   panels (all present in the DOM); JS just toggles which one shows. */
(function () {
  document.querySelectorAll('.vlx-fp').forEach(function (root) {
    var chips = root.querySelectorAll('[data-chip]');
    var panels = root.querySelectorAll('[data-panel]');
    if (!chips.length) return;
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var id = chip.getAttribute('data-chip');
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-panel') === id;
          p.hidden = !on;
          // The panel was hidden, so ScrollTrigger.batch never revealed its cards
          // — reveal them now (no-op if the motion layer isn't loaded).
          if (on && window.vlxReveal) window.vlxReveal(p);
        });
      });
    });
  });
})();
